import 'reflect-metadata';
import { Service } from 'typedi';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'sePublicCardStrategyService' })
export class SePublicCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new SePublicCardStrategyService(details);
  }
}

export class SePublicCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  productCardSources = [
    'ECAT_BSL',
    'ECAT_BSL_SUB',
    'CLIPSAL',
    'NAV_PES',
    'FAMILY_PES',
    'OFFER_PES',
    'PRD_SDLPAGE',
    'OFFER_PROMOTED',
    'ORACLE_CROSSREF',
  ];

  makeCard(doc: SearchApiDocument): string {
      const isRedesignedCard = this.details?.params?.isSidePanelFeature || false;
      switch (true) {
      case isRedesignedCard:
        return 'uiaas-search-result-product-card-side-panel';
      case this.productCardSources.includes(doc.source):
        return 'uiaas-search-result-product';
      case doc.source === 'VIDEO' && doc.f1Symbol !== 'Company' && doc.f1Symbol !== 'Solutions':
        return 'uiaas-search-result-video-v2';
      case ['community_articles', 'community_forum'].includes(doc.source):
        return 'uiaas-search-result-community-support';
      case doc.source === 'BSL_DOC':
        return 'uiaas-search-result-document-v1';
      default:
        return 'uiaas-search-result-basic-v2';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
